import { ChartTimeSeriesLineTheme } from '@hcs/design-system';
import { DateStr } from '@hcs/types';

import { CerberusStatsRpiChart } from '../../components/CerberusStatsRpiChart';
import { MACRO_INSIGHTS_FROM_DATE } from '../../constants/marketInsights.constants';
import { useMsaRpiTimeSeries } from '../../hooks/useMsaRpiTimeSeries';

const dataHcName = 'msa-rpi-chart';

interface MsaHpiChartProps {
  className?: string;
  msaId: string;
  fromDate?: DateStr;
  toDate?: DateStr;
  theme?: Partial<ChartTimeSeriesLineTheme>;
}
export const MsaRpiChart = ({
  msaId,
  className,
  fromDate = MACRO_INSIGHTS_FROM_DATE,
  toDate,
  theme,
}: MsaHpiChartProps) => {
  const { data, isLoading } = useMsaRpiTimeSeries({
    msaId,
    fromDate,
    toDate,
  });
  return (
    <CerberusStatsRpiChart
      dataHcName={dataHcName}
      className={className}
      data={data}
      theme={theme}
      isLoading={isLoading}
    />
  );
};
